import { makeStyles } from '@material-ui/styles'

const loginStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#F7F6FC',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  title: {
    marginTop: theme.spacing(0.8),
  },
  subTitle: {
    marginTop: theme.spacing(0.8),
    marginBottom: theme.spacing(3.2),
  },
  textField: {
    marginBottom: theme.spacing(2.4),
  },
}))

export default loginStyles
